import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import FormContent from './FormContent';
import { MODAL_PRESENTATION_FORM, hideModal, MODAL_PRESENTATION_COPY } from '../../../../../../modules/modals';

class CopyModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_PRESENTATION_COPY});

  }

  getTitle = () => {
    const {initialValues} = this.props;
    const {formatMessage} = this.context
    let text = "frmTitleCopyPresentation";
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const { zIndex } = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <FormContent {...this.props} handleClose={this.handleClose} />
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/PresentationItems/components/CopyModal/index.jsx